import { useQuery } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getWallets } from 'services/WalletsService'

export const useWalletsQuery = () => {
  return useQuery(reactQueryKeys.wallets(), getWallets, {
    refetchOnWindowFocus: false,
    onError: error => logSentryError('Error from useWalletsQuery - getWallets', error),
  })
}
